export const CHILIPIPER_DEANON_EVENT =
  'CHILIPIPER_DEANON_INTERNAL_EVENT_DONT_USE_OR_YOU_WILL_BE_FIRED'

export const CHILIPIPER_DEANON_AND_TRACKING_INTEGRATION_EVENT =
  'CHILIPIPER_DEANON_AND_TRACKING_INTEGRATION_INTERNAL_EVENT_DONT_USE_OR_YOU_WILL_BE_FIRED'

export const CHILIPIPER_DEANON_CLASS = 'chilipiper-deanon-iframe'

// The global the web-data deployment's env-config.js assigns. Every Chili Piper app reads its
// runtime config from `_env_`; the web-data bundles run inside other people's pages, our own apps
// included, so theirs lives under a name nothing else on a page uses. Read through shared/env.ts.
// Also spelled out in apps/web-data-snippet/package.json (the generator's ENV_CONFIG_GLOBAL_NAME)
// and in src/types.d.ts; fe-deploy/generate-env-config.test.mjs keeps the copies in step.
export const CHILIPIPER_WEB_DATA_ENV_GLOBAL =
  'CHILIPIPER_WEB_DATA_INTERNAL_ENV_DONT_USE_OR_YOU_WILL_BE_FIRED'
